(function () {
  var header = document.querySelector("[data-header]");

  if (!header) {
    return;
  }

  var menuButton = header.querySelector("[data-header-menu]");
  var drawer = header.querySelector("[data-header-drawer]");
  var panel = drawer.querySelector(".header__drawer-panel");
  var closeButtons = header.querySelectorAll("[data-header-drawer-close]");
  var drawerLinks = drawer.querySelectorAll(".header__drawer-link, .header__drawer-sublink");
  var submenuToggles = drawer.querySelectorAll("[data-drawer-submenu-toggle]");
  var mobileQuery = window.matchMedia("(max-width: 1024px)");

  function isMobile() {
    return mobileQuery.matches;
  }

  function openMenu() {
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-menu-open");
    menuButton.setAttribute("aria-expanded", "true");

    requestAnimationFrame(function () {
      header.classList.add("header--menu-open");
    });
  }

  function closeMenu() {
    if (!header.classList.contains("header--menu-open")) {
      return;
    }

    header.classList.remove("header--menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    closeAllSubmenus();

    panel.addEventListener("transitionend", onCloseEnd);
  }

  function onCloseEnd(event) {
    if (event.target !== panel || event.propertyName !== "transform") {
      return;
    }

    panel.removeEventListener("transitionend", onCloseEnd);
    document.body.classList.remove("is-menu-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function closeAllSubmenus() {
    submenuToggles.forEach(function (toggle) {
      var submenuId = toggle.getAttribute("aria-controls");
      var submenu = submenuId ? document.getElementById(submenuId) : null;
      toggle.setAttribute("aria-expanded", "false");
      if (submenu) submenu.hidden = true;
    });
  }

  function toggleSubmenu(toggle) {
    var expanded = toggle.getAttribute("aria-expanded") === "true";
    var submenuId = toggle.getAttribute("aria-controls");
    var submenu = submenuId ? document.getElementById(submenuId) : null;
    if (!submenu) return;

    // Accordion: close other open submenus
    submenuToggles.forEach(function (other) {
      if (other === toggle) return;
      var otherId = other.getAttribute("aria-controls");
      var otherMenu = otherId ? document.getElementById(otherId) : null;
      other.setAttribute("aria-expanded", "false");
      if (otherMenu) otherMenu.hidden = true;
    });

    toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
    submenu.hidden = expanded;
  }

  menuButton.addEventListener("click", openMenu);

  closeButtons.forEach(function (button) {
    button.addEventListener("click", closeMenu);
  });

  drawerLinks.forEach(function (link) {
    link.addEventListener("click", closeMenu);
  });

  submenuToggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleSubmenu(toggle);
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && header.classList.contains("header--menu-open")) {
      closeMenu();
      menuButton.focus();
    }
  });

  mobileQuery.addEventListener("change", function () {
    if (!isMobile()) {
      closeMenu();
    }
  });
})();
